export default __webpack_public_path__ + "static/media/gallery_06.7d2b14cd.jpg";